<template>
  <div class="page">
    <div class="text-center">
      <el-button @click="handleReset" type="danger">我要重新抽取</el-button>
      <el-button @click="handleLast">上一步</el-button>
      <el-button type="primary" @click="handleNext">下一步</el-button>
    </div>
    <el-divider></el-divider>

    <el-card class="mt10" v-for="item in tableData" :key="item.sortNum">
      <div slot="header" class="clearfix">
        抽取需求批次
        <span v-text="item.sortNum"></span>
        <el-tag class="ml10">
          状态：
          <span v-text="item.stateName"></span>
        </el-tag>
      </div>
      <div>
        <div class="mt10">
          <mavin :batchEid="item.batchEid" ref="Mavin"></mavin>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Mavin from './components/Mavin.vue';

import { GainVer } from '@/utils/gains/version.js';
import { listBatch } from '@/api/gains/batch.js';

export default {
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  components: {
    Mavin
  },
  methods: {
    handleReset() {
      this.$router.push(
        `/gains/${this.$route.params.ver}/${this.$route.params.gainEid}/para`
      );
    },
    handleLast() {
      var ver = this.$route.params.ver;
      var gainVer = new GainVer(ver);

      if (gainVer.isVer2()) {
        this.$router.push(
          `/gains/${ver}/${this.$route.params.gainEid}/mavin/scope`
        );
      } else if (gainVer.isVer3()) {
        this.$router.push(`/gains/${ver}/${this.$route.params.gainEid}/para`);
      }
    },
    handleNext() {
      this.$router.push(
        `/gains/${this.$route.params.ver}/${this.$route.params.gainEid}/promise`
      );
    },
    listBatch() {
      this.loading = true;

      listBatch(this.$route.params.gainEid, false, true).then(res => {
        this.tableData = res;
        this.loading = false;
      });
    }
  },
  created() {
    var gainVer = new GainVer(this.$route.params.ver);
    if (gainVer.isVer2()) {
      this.$emit('loaded', 5);
    } else if (gainVer.isVer3()) {
      this.$emit('loaded', 4);
    }
    this.listBatch();
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 10px;
}
</style>
